import React, { useRef, useState } from 'react';

import './App.css';

import {
  Tabs,
  Tag,
  Input,
  Typography,
} from 'antd';
import 'antd/dist/reset.css';

import { useIsMobile } from './hooks/useIsMobile';

import StockReport from './StockReport';
import DisclosureViewer from './DisclosureViewer';
import EconomicCalendar from './EconomicCalendar';
import TotalDart from './TotalDart';
import TotalIR from './TotalIR';
import SpellCheck from './Spell';
import ExclusiveNews from './ExclusiveNews';
import SocialNews from './SocialNews';
import PitchHelper from './PitchHelper';

const { TabPane } = Tabs;

const App = () => {
  const isMobile = useIsMobile();
  const [searchForTotalDart, setSearchForTotalDart] = useState('');
  const [activeTab, setActiveTab] = useState('spell');
  const tabsRef = useRef<HTMLDivElement>(null);

  return (
    <div className="App">
      <div
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: '20px',
        }}
      >
        <Typography.Title
          level={3}
          style={{
            marginBottom: 16,
          }}
        >
          📰 뉴스 랩 (News Lab)
        </Typography.Title>
        <button
          type="button"
          aria-label="사회부 발제 도우미 열기"
          onClick={() => {
            setActiveTab('pitch');
            tabsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }}
          style={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            marginBottom: 24,
            padding: isMobile ? '14px 16px' : '16px 22px',
            border: 'none',
            borderRadius: 12,
            cursor: 'pointer',
            textAlign: 'left',
            color: '#fff',
            background: 'linear-gradient(135deg, #1677ff 0%, #0958d9 60%, #003eb3 100%)',
            boxShadow: '0 4px 14px rgba(22, 119, 255, 0.35)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: isMobile ? 26 : 30 }} aria-hidden>
              🗞️
            </span>
            <div>
              <div style={{ fontWeight: 800, fontSize: isMobile ? 16 : 18 }}>
                사회부 발제 도우미
                <span
                  style={{
                    marginLeft: 8,
                    fontSize: 11,
                    fontWeight: 700,
                    padding: '1px 6px',
                    borderRadius: 4,
                    background: '#fff',
                    color: '#0958d9',
                    verticalAlign: 'middle',
                  }}
                >
                  NEW
                </span>
              </div>
              <div style={{ fontSize: isMobile ? 12 : 13, opacity: 0.9, marginTop: 2 }}>
                기사화되기 전 이슈를 먼저 — 트렌드 · 커뮤니티 이슈 · 생활 의문·불만
              </div>
            </div>
          </div>
          <span style={{ fontWeight: 700, fontSize: 14, whiteSpace: 'nowrap' }}>바로 보기 →</span>
        </button>
        <div ref={tabsRef} />
        <Tabs activeKey={activeTab} onChange={setActiveTab} type="card">
          <TabPane tab="맞춤법 체크" key="spell">
            <SpellCheck />
          </TabPane>
          <TabPane
            tab={
              <span>
                단독 기사{' '}
                <Tag color="orange" style={{ fontSize: 10, padding: '0 4px', marginLeft: 2 }}>
                  Beta
                </Tag>
              </span>
            }
            key="exclusive"
          >
            <ExclusiveNews />
          </TabPane>
          <TabPane
            tab={
              <span>
                사회부 발제 도우미{' '}
                <Tag color="blue" style={{ fontSize: 10, padding: '0 4px', marginLeft: 2 }}>
                  New
                </Tag>
              </span>
            }
            key="pitch"
          >
            <PitchHelper />
          </TabPane>
          <TabPane tab="사회부 기사" key="social">
            <SocialNews />
          </TabPane>
          <TabPane tab="국내기업 실적발표 일정" key="ir">
            <TotalIR />
          </TabPane>
          <TabPane tab="전자 공시" key="dart">
            <Tabs>
              <TabPane tab="날짜별" key="date">
                <Input.Search
                  style={{
                    width: isMobile ? '80vw' : 500,
                    marginBottom: 20,
                  }}
                  placeholder="검색어를 입력하세요 (공시 통합검색)"
                  value={searchForTotalDart}
                  onChange={(e) => {
                    setSearchForTotalDart(e.target.value);
                  }}
                />
                <div
                  style={{
                    alignItems: 'flex-start',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: 20,
                  }}
                >
                  <DisclosureViewer type="dart" searchForTotalDart={searchForTotalDart} />
                  <DisclosureViewer type="kind" searchForTotalDart={searchForTotalDart} />
                </div>
              </TabPane>
              <TabPane tab="과거 통합검색" key="total">
                <TotalDart />
              </TabPane>
            </Tabs>
          </TabPane>
          <TabPane tab="증시" key="stock">
            <StockReport />
          </TabPane>
          <TabPane tab="경제 지표" key="calendar">
            <EconomicCalendar />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default App;
